import { JustpayInventoryEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-inventory-endpoint-service"

export class JustpayInventoryService {
    constructor () {
        this.justpayInventoryEndpointService = new JustpayInventoryEndpointService()
    }

    async getInit (id) {
        const response = await this.justpayInventoryEndpointService.getInventories({ id: id })
        response.data = response.data.length > 0 ? response.data[0] : {}
        return response
    }

    async getInventories (arg) {
        return this.justpayInventoryEndpointService.getInventories(arg)
    }

    async changeInventory (request) {
        return this.justpayInventoryEndpointService.changeInventory(request)
    }

    async createInventory (request) {
        return this.justpayInventoryEndpointService.createInventory(request)
    }

    async downloadData (request) {
        return this.justpayInventoryEndpointService.downloadData(request)
    }
}
